import axios from 'axios';
import {addressValidationApi} from '../../utils/constants/EndPoint';

export function addressValidationService(customerData, appConfig) {
  const userAddress = {
    streetAddress: customerData.streetAddress.value,
    apartment: customerData.apartment.value,
    city: customerData.city.value,
    stateOrProvince: customerData.stateOrProvince.value,
    postalCode: customerData.postalCode.value,
    countryCode: customerData.countryCode.value
  };
  const apiUrl = appConfig?.exrServiceApi;
  return axios.post(apiUrl + addressValidationApi, userAddress);
}
